var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_707",
    "data-name": "Group 707",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12760",
    "data-name": "Path 12760",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12761",
    "data-name": "Path 12761",
    d: "M8.316,26.192a1.29,1.29,0,0,1-1.29-1.29v-2a.79.79,0,0,0-.79-.789A2.334,2.334,0,0,1,3.9,19.781V8.588A2.334,2.334,0,0,1,6.236,6.256H23.765A2.334,2.334,0,0,1,26.1,8.588V19.781a2.334,2.334,0,0,1-2.331,2.332H13.317a.786.786,0,0,0-.554.226L9.218,25.822a1.285,1.285,0,0,1-.9.37M6.236,7.8a.79.79,0,0,0-.79.79V19.781a.791.791,0,0,0,.79.79A2.334,2.334,0,0,1,8.568,22.9v1.4l3.115-3.06a2.317,2.317,0,0,1,1.634-.668H23.765a.792.792,0,0,0,.79-.79V8.588a.791.791,0,0,0-.79-.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12762",
    "data-name": "Path 12762",
    d: "M17.968,15.47a2.053,2.053,0,0,1-.554,1.4,2.647,2.647,0,0,1-1.445.766v.646a.653.653,0,1,1-1.306,0v-.648a2.463,2.463,0,0,1-1.972-1.678.64.64,0,0,1,.1-.567.661.661,0,0,1,.528-.264.652.652,0,0,1,.62.447,1.3,1.3,0,0,0,1,.821l.051.01.055.01.054.008.06,0,.017,0,.032,0,.086,0h.039c.037,0,.075,0,.113,0l.047,0,.081-.008.048-.006.06-.011.041-.007c.576-.117.935-.469.941-.918.006-.606-.47-.837-1.352-1.049-.08-.021-.161-.039-.242-.059-1.008-.236-2.261-.531-2.261-2.115A2.028,2.028,0,0,1,14.663,10.2V9.566a.653.653,0,1,1,1.306,0v.649A2.171,2.171,0,0,1,17.7,11.647a.654.654,0,0,1-.624.852.663.663,0,0,1-.623-.441.994.994,0,0,0-.739-.6l-.078-.016-.014,0a.743.743,0,0,0-.078-.013l-.032,0-.059-.005-.045,0-.068,0H15.3q-.061,0-.12,0l-.033,0-.082.007-.04.005c-.027,0-.052.008-.079.012l-.03.005c-.241.047-.806.218-.812.79s.449.7,1.322.909l.137.033c.783.183,2.414.566,2.4,2.29",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuote);
export default __webpack_public_path__ + "static/media/icon-quote.23f157ec5107c168c818ce7b64379264.svg";
export { ForwardRef as ReactComponent };